import React, { MouseEvent } from "react";

import { IgTypography } from "@intelligems/ig-theme";
import { WidgetType } from "@intelligems/ig-types";
import { Grid } from "@mui/material";
import { ColorSwatch } from "@src/components/ColorAndStyle/sections/components/ColorSwatch";

import { ColorFieldConfig } from "../../types";

interface ColorsColumnProps {
  widgetType?: WidgetType;
  colorFields: ColorFieldConfig[];
  sectionTitle: string;
  onColorChange: (field: string, event: MouseEvent<HTMLElement>) => void;
  xs?: number;
  enableTwoColumnLayout?: boolean;
  twoColumnThreshold?: number;
}

export const ColorsColumn = ({
  colorFields,
  sectionTitle,
  onColorChange,
  xs = 3,
  enableTwoColumnLayout = false,
  twoColumnThreshold = 2,
}: ColorsColumnProps) => {
  const midpoint = Math.ceil(colorFields.length / 2);
  const firstColumn = colorFields.slice(0, midpoint);
  const secondColumn = colorFields.slice(midpoint);

  return (
    <Grid item container direction="column" xs={xs} spacing={2}>
      <Grid item>
        <IgTypography
          variant="body1"
          sx={{ wordWrap: "break-word", overflowWrap: "break-word" }}
        >
          {sectionTitle}
        </IgTypography>
      </Grid>
      <Grid item container>
        {enableTwoColumnLayout && colorFields.length >= twoColumnThreshold ? (
          <Grid item container spacing={2}>
            <Grid item xs={6} container direction="column" spacing={3}>
              {firstColumn.map(({ key, label, color }) => (
                <ColorSwatch
                  key={key}
                  fieldKey={key}
                  color={color}
                  label={label}
                  onColorChange={onColorChange}
                />
              ))}
            </Grid>
            {secondColumn.length > 0 && (
              <Grid item xs={6} container direction="column" spacing={3}>
                {secondColumn.map(({ key, label, color }) => (
                  <ColorSwatch
                    key={key}
                    fieldKey={key}
                    color={color}
                    label={label}
                    onColorChange={onColorChange}
                  />
                ))}
              </Grid>
            )}
          </Grid>
        ) : (
          <Grid item container direction="column" spacing={3}>
            {colorFields.map(({ key, label, color }) => (
              <ColorSwatch
                key={key}
                fieldKey={key}
                color={color}
                label={label}
                onColorChange={onColorChange}
              />
            ))}
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};
